/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AutomaticEmailStepOverrideEmailThreadMode = typeof AutomaticEmailStepOverrideEmailThreadMode[keyof typeof AutomaticEmailStepOverrideEmailThreadMode] | null;


export const AutomaticEmailStepOverrideEmailThreadMode = {
  new_thread: 'new_thread',
  reply: 'reply',
} as const;
